const runtimeConfig = window.runtimeConfig || {};

const config = {
  apiUrl: runtimeConfig.REACT_APP_API_URL || process.env.REACT_APP_API_URL,
  refreshTime:
    runtimeConfig.REACT_APP_REFRESH_TIME || process.env.REACT_APP_REFRESH_TIME,
  baseName: runtimeConfig.REACT_APP_BASENAME || process.env.REACT_APP_BASENAME,
  jwtToken:
    runtimeConfig.REACT_APP_JWT_TOKEN || process.env.REACT_APP_JWT_TOKEN,
  shopId: runtimeConfig.REACT_APP_SHOP_ID || process.env.REACT_APP_SHOP_ID,
  envType: runtimeConfig.REACT_APP_ENV_TYPE || process.env.REACT_APP_ENV_TYPE,
};

export default config;
